import './App.css';
import HeaderComponent from './components/Header';
import React, { useState, useEffect, useRef } from 'react';
import { Space, Flex, Layout, Table, message } from 'antd';
import unit from './unit';

const { Content } = Layout;

const MyFollow = (props) => {
    // 使用 useState 来管理状态
    const [page, setPage] = useState(1);
    const [pagecount, setPagecount] = useState(50);
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const [columns, setColumns] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const childRef = useRef(null);
    // 存储当前的排序字段和顺序
    const [sortState, setSortState] = useState({
        field: 'follow_time',
        order: 'desc'
    });
    // 存储总数据量
    const [count, setCount] = useState(0);
    // 存储高亮行的 key
    const [highlightedRowKeys, setHighlightedRowKeys] = useState([]);
    
    // 股东详细列表
    const getDetailList = (page = 1, pagesize = 50, sortField = 'follow_time', sortOrder = 'desc') => {
        const path = '/pc/gudong/myFollow';
        setLoading(true);
        unit.httpGet(path, {
            "page": page,
            "pageSize": pagesize,
            "sortField": sortField,
            "sortOrder": sortOrder
        }, (data) => {
            let dataSource = [];
            setCount(data.count);
            setName(data.name);
            if (data.list.length > 0) {
                for (let i = 0; i < data.list.length; i++) {
                    let tmp = {};
                    tmp['index'] = i + 1; 
                    tmp['name'] = data.list[i].name;
                    tmp['follow_time'] = data.list[i].follow_time;
                    tmp['last_updtime'] = data.list[i].last_updtime;
                    tmp['change_percent'] = data.list[i].change_percent;
                    tmp['type'] = data.list[i].type;
                    tmp['code'] = data.list[i].code; 
                    dataSource.push(tmp);
                }
                setDataSource(dataSource);
            }
            
            const newColumns = [
                {
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    render: (text, record, index) => {
                        // 动态计算序号，考虑分页和排序
                        return (page - 1) * pagesize + index + 1;
                    }
                },
                {
                    title: '股东名称',
                    dataIndex: 'name',
                    key: 'name',
                    className: 'gudong',
                },
                {
                    title: '关注日期',
                    dataIndex: 'follow_time',
                    key: 'follow_time',
                    sorter: (a, b) => a.follow_time.localeCompare(b.follow_time),
                    sortDirections: ['descend', 'ascend', 'descend'],
                    align: 'center',
                    sortOrder: sortField === 'follow_time' ? sortOrder === 'desc' ? 'descend' : 'ascend' : null
                },
                {
                    title: '最新数据更新',
                    dataIndex: 'last_updtime',
                    key: 'last_updtime',
                    sorter: (a, b) => a.last_updtime.localeCompare(b.last_updtime),
                    sortDirections: ['descend', 'ascend', 'descend'],
                    align: 'center',
                    render: (text) => {
                        // 格式化日期
                        if (text) {
                            if (!text.includes('-')) {
                                const year = text.substring(0, 4);
                                const month = text.substring(4, 6);
                                const day = text.substring(6, 8);
                                return `${year}-${month}-${day}`;
                            }
                            return text;
                        }
                        return '';
                    },
                    sortOrder: sortField === 'last_updtime' ? sortOrder === 'desc' ? 'descend' : 'ascend' : null
                },
                {
                    title: '较上期变化',
                    dataIndex: 'change_percent',
                    key: 'change_percent',
                    sorter: (a, b) => {
                        // 处理特殊值'--'
                        const valA = a.change_percent === '--' ? 0 : parseFloat(a.change_percent);
                        const valB = b.change_percent === '--' ? 0 : parseFloat(b.change_percent);
                        return valA - valB;
                    },
                    sortDirections: ['descend', 'ascend', 'descend'],
                    align: 'center',
                    render: (text) => {
                        const isPositive = text > 0;
                        if (text === '--') {
                            return (<span style={{ color: '#666'}}>{text}</span>)
                        } 
                        return (
                            <span style={{ color: isPositive ? '#F23031' : 'green' }}>
                                {isPositive ? '+' : ''}{text}%
                            </span>
                        );
                    },
                    sortOrder: sortField === 'change_percent' ? sortOrder === 'desc' ? 'descend' : 'ascend' : null
                },
                {
                    title: '操作',
                    key: 'operation',
                    render: (_, record) => (
                        <Space size="middle">
                            <a onClick={(e) => handleUnfollow(e, record)}>取消关注</a>
                        </Space>
                    )
                }
            ];
            
            setColumns(newColumns);
            setLoading(false);
        });
    };

    // 处理取消关注
    const handleUnfollow = (e, record) => {
        e.stopPropagation(); // 阻止事件冒泡
        const path = '/pc/gudong/unfollow';
        unit.httpGet(path, {
            "type": record.type,
            "code": record.code,
        }, (data) => {
            console.log('取消关注回调数据:', data);
            message.success('取消关注成功');
            // 从高亮列表中移除被取消关注的项
            setHighlightedRowKeys(prev => prev.filter(key => key !== record.code));
            getDetailList(page, pagecount, sortState.field, sortState.order);
        }, (error) => {
            console.log('取消关注失败:', error);
            message.error('取消关注失败');
        });
    };

    // 处理整行点击事件
    const handleRowClick = (record) => {
        console.log("Clicked record code:", record.code); 
        
        // 更新高亮行状态
        setHighlightedRowKeys([record.code]);
  
        if (record.type == 1) {
            window.open(`/detail/${record.code}`);
        } else {
            window.open(`/particulars/${record.code}`);
        }
    };

    // 处理表格变化事件，如分页、排序、筛选
    const handleTableChange = (pagination, filters, sorter) => {
        // 更新分页和排序状态
        setPage(pagination.current);
        setPagecount(pagination.pageSize);
        
        // 处理排序
        if (sorter.field) {
            setSortState({
                field: sorter.field,
                order: sorter.order === 'ascend' ? 'asc' : 'desc'
            });
        } else {
            // 如果没有排序字段，重置排序状态
            setSortState({
                field: 'follow_time',
                order: 'desc'
            });
        }
        
        // 重新获取数据，确保序号正确
        getDetailList(pagination.current, pagination.pageSize, sorter.field || 'follow_time', sorter.order === 'ascend' ? 'asc' : 'desc');
    };

    // 页面加载和状态变化时获取数据
    useEffect(() => {
        getDetailList(page, pagecount, sortState.field, sortState.order);
    }, [page, pagecount, sortState.field, sortState.order]);

    return (
        <div className="App">
            <Flex gap="middle" wrap>
                <Layout>
                <HeaderComponent ref={childRef} />
                    <Content>
                        <div className='body' style={{ background: "#FFFFFF", borderRadius: "7px 7px 7px 7px" }}>
                            <div className='row'>
                                <div className='left title'>{name}我的关注</div>
                                <div className='right update_time'></div>
                                <div className='clear'></div>
                            </div>
                            <div className='table' style={{ cursor: 'pointer' }}>
                                <Table 
                                    size='small' 
                                    cursor='pointer' 
                                    loading={loading} 
                                    locale={{ cancelSort: "点击取消排序", triggerAsc: "点击升序", triggerDesc: "点击降序", emptyText: "暂无数据" }} 
                                    pagination={{
                                        current: page,
                                        pageSize: pagecount,
                                        total: count,
                                        showSizeChanger: false,
                                        showQuickJumper: true,
                                        locale: {
                                            jump_to: '跳至',
                                            jump_to_confirm: '确定',
                                            page: '页',
                                            prev_page: '上一页',
                                            next_page: '下一页'
                                        }
                                    }}
                                    columns={columns} 
                                    dataSource={dataSource} 
                                    rowClassName={(record, index) => 
                                        highlightedRowKeys.includes(record.code) ? 'highlighted-row' : ''
                                    }
                                    onChange={handleTableChange}
                                    onRow={(record) => {
                                        return {
                                            onClick: (e) => {
                                                if (!e.target.closest('.ant-table-cell a')) {
                                                    handleRowClick(record);
                                                }
                                            }
                                        };
                                    }}
                                ></Table>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Flex>
        </div>
    );
};

export default MyFollow;